export const mutations = {
    setLancamentoBancario(state, data) {
        state.lancamentoBancario = data
    },
    setLancamentosBancarios(state, data) {
        state.lancamentosBancarios = data
    },
    addLancamentoBancario(state, data){
        if(state.lancamentosBancarios.data){
            state.lancamentosBancarios.data.unshift(data)
        }
    },
    removeLancamentoBancario(state, data){
        let index = state.lancamentosBancarios.data.map(x => x.id).indexOf(data.id);
        state.lancamentosBancarios.data.splice(index, 1)
    },
    setModalCadastroLancamentoBancario(state, status) {
        state.modalCadastroLancamentoBancario = status
    },
    setModalExcluirLancamentoBancario(state, status) {
        state.modalExcluirLancamentoBancario = status
    },
    setShowInputAnexoLancamentoBancario(state, status) {
        state.showInputAnexoLancamentoBancario = status
    },
    
}

export default {}